import React from "react";
import { Link } from "react-router-dom";
import backimg from '../../../assets/solutions-images/hero_ban_itoperation.webp';
import "../solution.css"
const ItOperations = () => {
    return (
        <>
            <div>
                <div
                    className="bg-cover bg-center bg-no-repeat min-h-[502px] flex flex-col gap-8 justify-center px-6 py-16 md:px-8 lg:px-16 hover_herosec"
                    style={{ backgroundImage: `url(${backimg})` }}
                >
                    <h1 style={{ wordSpacing: '8px' }} data-aos="fade-down" className="text-xl md:text-3xl lg:text-5xl font-semibold text-white max-w-[100%] w-[300px] sm:w-full md:w-2/3 lg:w-[880px]">
                        Drive operational efficiency and innovation
                    </h1>
                    <p className="text-white text-sm w-full md:w-2/3 lg:w-[558px] xl:w-[590px]" data-aos="fade-down">
                        Partner with Tekpossible to unlock the full potential of ServiceNow ITOM and transform your IT operations from reactive to proactive. We'll help you address manual processes, visibility gaps, and event noise.
                    </p>
                    <Link
                        data-aos="zoom-in"
                        data-aos-delay="300"
                        to="/contact-us"
                        className="w-[100px] w-fit sm:w-[150px] md:w-[140px] text-semibold lg:w-[150px] bg-[#C32A7C] px-5 py-2 sm:px-6 sm:py-2.5 lg:px-7 lg:py-2 rounded-lg text-white  hover:bg-white hover:text-[#C32A7C] transition-colors duration-400 ease-in-out text-sm sm:text-sm md:text-sm lg:text-lg text-center whitespace-nowrap"
                    >
                        Contact Us
                    </Link>

                </div>
            </div>


            <div className="bg-[#FFFFFF] mt-6 mb-10">

                <div className="flex flex-col sm:justify-center text-center items-center gap-4 py-8 px-4">
                    <h1 className="text-[#1A5298] font-bold text-lg md:text-3xl">
                        How can ServiceNow ITOM solutions help you improve your IT operations?
                    </h1>
                </div>

                <div className="bg-white">
                    <div data-aos="zoom-in-down" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-10 px-4 md:px-10 lg:px-10 py-5 items-start">
                        <div className="flex flex-col items-center w-2/1 text-center justify-center lined_hoverset">
                            <h2 className="text-[#000] text-base lg:text-[15px] xl:text-xl font-semibold w-[200px] md:max-w-[253px] text-center">Gain actionable intelligence</h2>
                            <div className="mt-2 flex flex-col items-center md:w-40 ">
                                <img
                                    className="object-contain my-5"
                                    src={require("../../../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-center text-black max-w-[361px]">
                                Achieve complete visibility into your IT infrastructure, map your digital services, and maintain a real-time, up-to-date ServiceNow CMDB.
                            </p>
                        </div>
                        <div className="flex flex-col items-center w-2/1 text-center justify-center lined_hoverset">
                            <h2 className="text-[#000] text-base lg:text-[15px] xl:text-xl font-semibold  max-w-[353px] text-center">Proactively resolve issues to prevent customer impact</h2>
                            <div className="mt-2 flex flex-col items-center md:w-40 ">
                                <img
                                    className="object-contain my-5"
                                    src={require("../../../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-center text-black max-w-[501px]">
                                Prevent user impact by predicting issues, analyzing increasing alert noise, and swiftly remediating incidents.
                            </p>
                        </div>
                        <div className="flex flex-col items-center justify-center w-2/1 text-center justify-center lined_hoverset">
                            <h2 className="text-[#000] text-base lg:text-[15px] xl:text-xl font-semibold  max-w-[253px] text-center">Navigate your cloud transition effortlessly</h2>
                            <div className="mt-2 flex flex-col items-center md:w-40 ">
                                <img
                                    className="object-contain my-5"
                                    src={require("../../../assets/solutions-images/line_gapers.svg").default}
                                    alt="Enhance IT Workflows"
                                />
                            </div>
                            <p className="text-center text-black max-w-[361px]">
                                Seamlessly implement cloud deployment controls and consolidate workloads to maintain efficiency.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="bg-[#F4F4F4] w-full py-10 md:py-12">
                <div className="flex flex-col items-center text-center px-4 md:px-6">

                    <h1 data-aos="fade-down" data-aos-duration="1000" className="text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-5 w-full">
                        Our ServiceNow ITOM proficiency
                    </h1>
                    <h5 data-aos="fade-up" data-aos-duration="1000" className="text-md text-black font-medium text-center max-w-[760px]">Agent Client Collector | Log Analytics | Cloud Deployment & Governance | Discovery | Event Management | Service Mapping</h5>

                </div>
            </div>
            <div className="bg-[#FFFFFF] w-full py-10 md:py-12">
                <div className="flex flex-col items-center text-center px-4 md:px-6">

                    <h1 data-aos="fade-up" data-aos-duration="1000" className="line_heightsests text-[#1A5298] font-bold text-xl md:text-2xl lg:text-4xl text-center mb-8 w-full md:w-2/2 lg:w-2/3">
                        Let's work together to maximize the value of your ServiceNow ITOM investment.
                    </h1>
                    <Link
                        data-aos="zoom-in"
                        data-aos-delay="200"
                        to={"/contact-us"}
                        className="w-[140px] px-6 py-2 md:px-4 md:py-2.5 bg-[#C32A7C] rounded-lg text-white font-semibold 
                        hover:bg-[#F6F6F6] hover:text-[#C32A7C] transition-colors duration-300 text-sm md:text-base 
                        text-center whitespace-nowrap mt-4 border border-[#C32A7C]"
                    >
                        Contact Us
                    </Link>

                </div>
            </div>
        </>
    );
}

export default ItOperations;